module.exports = __webpack_public_path__ + "img/dggjbanner.9e0b4794.jpg";